import { render, staticRenderFns } from "./Redis.vue?vue&type=template&id=3fa1bc4c"
import script from "./Redis.vue?vue&type=script&lang=js"
export * from "./Redis.vue?vue&type=script&lang=js"
import style0 from "./Redis.vue?vue&type=style&index=0&id=3fa1bc4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports